import React from 'react'
import { BrowserRouter, Route } from "react-router-dom";
import { WEISCHER_OVERVIEW_HERO } from '../constants/weischerTypes';
import { filterWeischerAds } from '../functions/weischerHelpers';
import withLatencyTest from '../hooks/withLatencyTest';
import PageOverviewMovie from './PageOverviewMovie';
import PageOverviewWrapper from './PageOverviewWrapper'
import getAdvertisementData from '../functions/getAdvertisementData';
import { ADVERTISEMENT_OVERVIEW_HERO } from '../constants/advertisementTypes';
import getCookie from '../functions/getCookie';
import EntryPagesChildClass from '../General/EntryPagesChildClass';
import getMomentDateObj from '../functions/getMomentDateObj';
import getMomentNow from '../functions/getMomentNow';
import { compose } from 'redux';
import { connect } from 'react-redux';
import toJS from '../hoc/toJS';
import getData from '../functions/getData';
import { ADVERTISEMENT_CONFIG, FEATURES, FRONT, PROGRAM_ADVERTISEMENTS, PROGRAM_MOVIES, PROGRAM_WEISCHERADS, ROUTESDATA, SITEHEADERDATA, THEME, TRANSLATION } from '../constants/state';
import hasCookieCheck from '../functions/hasCookieCheck';
import { setYoutubeCookieConfirmation } from '../actions';
import PageOverviewSignageContainer from './PageOverviewSignageContainer';
import withUseCssVars from '../hooks/withUseCssVars';
import { useFilteredMovies } from './useFilteredMovies';

const mapDispatchToProps = (dispatch, ownProps) => ({
    setYoutubeCookieConfirmation: (bool) => {
        dispatch(setYoutubeCookieConfirmation(bool))
    }
})

const mapStateToProps = (state, ownProps) => ({
    cinemaDataFront: getData(state, FRONT),
    movies: getData(state, PROGRAM_MOVIES),
    advertisements: getData(state, PROGRAM_ADVERTISEMENTS),
    features: getData(state, FEATURES),
    weischerAds: getData(state, PROGRAM_WEISCHERADS),
    theme: getData(state, THEME),
    routesData: getData(state, ROUTESDATA),
    translation: getData(state, TRANSLATION),
    advertisementConfig: getData(state, ADVERTISEMENT_CONFIG),
    siteHeaderData: getData(state, SITEHEADERDATA)
})
class PageOverview extends EntryPagesChildClass {
    constructor(props) {
        super(props)

        this.state = {
            isScrolled: false
        }

        this.onScrollPage = this.onScrollPage.bind(this)
    }

    componentDidMount() {
        window.addEventListener('scroll', this.onScrollPage)

        const { setYoutubeCookieConfirmation } = this.props
        window.addEventListener('borlabs-cookie-consent-saved', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
        window.addEventListener('borlabs-cookie-code-unblocked', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
        window.addEventListener('borlabs-cookie-handle-unblock', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScrollPage)
        
        const { setYoutubeCookieConfirmation } = this.props
        window.removeEventListener('borlabs-cookie-consent-saved', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
        window.removeEventListener('borlabs-cookie-code-unblocked', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
        window.removeEventListener('borlabs-cookie-handle-unblock', () => { hasCookieCheck(setYoutubeCookieConfirmation) })
    }

    onScrollPage() {
        if (window.scrollY > window.innerHeight && this.state.isScrolled === false) {
            this.setState({
                isScrolled: true
            })
        }
    }

    render() {
        const {
            isConnectedFast,
            cinemaDataFront,
            movies,
            advertisements,
            features,
            weischerAds,
            theme,
            routesData,
            translation,
            siteHeaderData
        } = this.props

        const {
            program_overview_showtimes_type,
            header_appearance,
            content_width,
            stripe_appearance,
            program_overview_startview_type,
            program_overview_subtitle,
            has_showtimes_feature,
            has_grid_trailer_feature,
            has_grid_hover_trailer,
            overview_filter_movies_with_attribute,
            hide_no_performance_movies
        } = cinemaDataFront

        const { has_chatbot } = features
        const { theme_colors } = theme
        const { timezone } = translation
        const filteredWeischerAds = filterWeischerAds(weischerAds, [WEISCHER_OVERVIEW_HERO])
        const filteredAdvertisements = getAdvertisementData(advertisements, [ADVERTISEMENT_OVERVIEW_HERO])
        const overviewHeroItems = filteredWeischerAds[WEISCHER_OVERVIEW_HERO]
        const overviewHeroAdvertisementItems = filteredAdvertisements[ADVERTISEMENT_OVERVIEW_HERO]
        const languages = translation.languages ? translation.languages : { de: {} }
        const cookieExists = getCookie('fireplace')
        const isScrolledClass = this.state.isScrolled || cookieExists ? ' is-scrolled' : ''



        const filteredMovies = useFilteredMovies(
            overview_filter_movies_with_attribute,
            hide_no_performance_movies,
            movies,
            timezone
        )

        // let filteredMovies = {
        //     items: {},
        //     order: []
        // }

        // if (overview_filter_movies_with_attribute && overview_filter_movies_with_attribute.length !== 0) {
        //     movies.order.map(moviePk => {
        //         const movie = movies.items[moviePk]
        //         const { technologyAttributes, performances, limitations } = movie
        //         const { visibleFrom } = limitations
        //         const technogolyAttributesIds = []
        //         let hideAllPerformances = false

        //         if (visibleFrom) {
        //             const performanceDate = getMomentDateObj(visibleFrom, timezone)
        //             hideAllPerformances = getMomentNow(timezone).isBefore(performanceDate)
        //         }


        //         if (technologyAttributes && technologyAttributes.length !== 0) {
        //             technologyAttributes.map(attr => {
        //                 //for when "Vorschau" movies get performances to show and aren't empty anymore
        //                 if (attr.name.toLowerCase() === 'vorschau' && performances.length > 0 && !hideAllPerformances) {
        //                     return ''
        //                 } else {
        //                     technogolyAttributesIds.push(attr.id)
        //                 }
        //             })
        //         }

        //         const compareArrays = _.intersection(overview_filter_movies_with_attribute, technogolyAttributesIds)

        //         if (compareArrays.length === 0) {
        //             filteredMovies.order.push(moviePk)
        //             filteredMovies.items[moviePk] = movie
        //         }
        //     })
        // } else {
        //     filteredMovies = movies
        // }

        // if(hide_no_performance_movies) {
        //     let moviesWithPerformances = {
        //         items: {},
        //         order: []
        //     }

        //     filteredMovies.order.map(moviePk => {
        //         const movie = movies.items[moviePk]
        //         const { performances } = movie

        //         if(performances.length > 0) {
        //             moviesWithPerformances.order.push(moviePk)
        //             moviesWithPerformances.items[moviePk] = movie
        //         }
        //     })

        //     filteredMovies = moviesWithPerformances
        // }

        return (
            <BrowserRouter>
                {Object.keys(languages).map(langKey => {
                    const langPath = translation.defaultLang === langKey ? '' : '/' + langKey

                    return ([
                        <Route
                            key={langKey + 'overview'}
                            path={langPath + "/:overviewParam"}
                            exact={true}
                            render={props => (
                                <PageOverviewWrapper
                                    location={props.location}
                                    hasChatbot={has_chatbot}
                                    match={props.match}
                                    movies={filteredMovies}
                                    routesData={routesData}
                                    headerAppearance={header_appearance}
                                    contentWidth={content_width}
                                    weischerAds={weischerAds}
                                    isScrolledClass={isScrolledClass}
                                    advertisements={advertisements}
                                    stripeAppearance={stripe_appearance}
                                    theme={theme_colors}
                                    translation={translation}
                                    siteHeaderData={siteHeaderData}
                                    programOverviewShowtimesType={program_overview_showtimes_type}
                                    programOverviewStartviewType={program_overview_startview_type}
                                    hasShowtimesFeature={has_showtimes_feature}
                                    hasGridTrailerFeature={has_grid_trailer_feature}
                                    hasGridHoverTrailer={has_grid_hover_trailer}
                                    overviewHeroItems={overviewHeroItems}
                                    overviewHeroAdvertisementItems={overviewHeroAdvertisementItems}
                                    features={features}
                                    isConnectedFast={isConnectedFast}
                                    overviewSubtitle={program_overview_subtitle}
                                />
                            )}
                        />,
                        <Route
                            key={langKey + 'overview-movie'}
                            path={langPath + "/:overviewParam/movie/:movieParam"}
                            exact={true}
                            render={props => (
                                <PageOverviewMovie
                                    location={props.location}
                                    overviewHeroItems={overviewHeroItems}
                                    overviewHeroAdvertisementItems={overviewHeroAdvertisementItems}
                                    isScrolledClass={isScrolledClass}
                                    match={props.match}
                                    isConnectedFast={isConnectedFast}
                                />
                            )}
                        />,
                        <Route
                            key={langKey + 'overview-signage-page'}
                            path={langPath + "/:overviewParam/signage/:signageParams"}
                            exact={true}
                            render={props => (
                              <PageOverviewSignageContainer 
                                match={props.match}
                                location={props.location}
                              />
                            )}
                        />
                    ])
                })}
            </BrowserRouter>
        )
    }
}


export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(withUseCssVars(withLatencyTest(PageOverview)))